import {
  UNSELECT_DELEGATES,
  SELECT_DELEGATES,
  UPDATE_DELEGATES,
  UNSELECT_ALL_DELEGATES
} from '../actions/index';

export default (state = [], action) => {
  switch (action.type) {
    case SELECT_DELEGATES:
      return state.find(i => action.payload[action.indexColumn.name] === i[action.indexColumn.name]) ? state : state.concat([action.payload]);
    case UNSELECT_DELEGATES:
      return state.filter(item => action.payload[action.indexColumn.name] !== item[action.indexColumn.name]);
    case UNSELECT_ALL_DELEGATES:
      return [];
    case UPDATE_DELEGATES:
      return state.map((item, index) => {
        if (item[action.indexColumn.name] === action.id) {
          return {...item, ...action.data};
        }
        return item;
      });
    default:
      return state;
  }
};
